import Flex from '@eversports/react-components/primitives/Flex'
import Text from '@eversports/react-components/primitives/Text'
import React from 'react'

export interface Helper {
  text: React.ReactNode
  isError: boolean
}

interface Props {
  helper?: Helper
}

const VoucherSelectionWrapper = ({ children, helper }: React.PropsWithChildren<Props>) => {
  const color = helper && helper.isError ? 'error.main' : 'primary.main'
  return (
    <Flex flexDirection="column" verticalSpacing="default">
      {children}
      {helper && (
        <Text size="x-small" color={color}>
          {helper.text}
        </Text>
      )}
    </Flex>
  )
}

export default VoucherSelectionWrapper
